import Header from './components/Header';
import Hero from './components/Hero';
import Gallery from './components/Gallery';
import Modes from './components/Modes';
import Testimonials from './components/Testimonials';
import Footer from './components/Footer';

function App() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Gallery />
        <Modes />
        <Testimonials />
      </main>
      <Footer />
    </>
  );
}

export default App;
